import { ProgramName } from '@/types/enrollment';

/** Helper function to format the program title.
 *  Only CLIMATE_RESPONSE is ClimateResponse® VPP */
export const formatProgramTitle = (programTitle: string, programDetailTitle: string, programName?: ProgramName) => {
  return programName === ProgramName.CLIMATE_RESPONSE || programName === ProgramName.DATA_ONLY
    ? `${programTitle}`
    : programDetailTitle;
};
